import React from 'react';
import { reactLocalStorage } from 'reactjs-localstorage';
import Form from 'react-bootstrap/Form';
import FormControl from 'react-bootstrap/FormControl';
import Button from 'react-bootstrap/Button';

import FieldMultiSelect from '../../common/FieldMultiSelect';
import ActionAPI from '../../../api/ActionAPI';
import Condition from './Condition';
import Const from '../../../util/Constants';
import withRouter from '../../../util/WithRouter';
import FieldController from '../../../controller/FieldController';
import Util from '../../../util/Util';
import ApiUiController from '../../../controller/ApiUiController';
import ActionModel from './ActionModel';

class ActionUpdate extends React.Component {

  constructor(props) {
    super(props);
    this.user = reactLocalStorage.getObject(Const.LoggedInUser);
    const id = parseInt(props.match.params.id);
    this.state = {
      inApiCall: id !== 0, id: id, name: '', description: '',
      condition: Const.True, changed: false
    };
    this.mainModel = reactLocalStorage.getObject(Const.Model);
    this.mainModel.view.fields.roles.editable = 1;
    this.mainModel.view.fields.users.editable = 1;

    this.modelName = null;
    this.model = null;
    this.fields = [];

    this.basePath = this.props.match.path
    this.basePath = this.basePath.substring(0, this.basePath.lastIndexOf('/'));

    this.conditions = [{}];
    this.autoModel = {};
  }

  componentDidMount() {
    if (this.state.id !== 0) {
      ActionAPI.get(this.state.id, this.onReceived, this.onFail);
    }
  }
  onFail = () => this.setState({ inApiCall: false });

  onReceived = action => {
    this.conditions = JSON.parse(action.conditions);
    if(this.conditions.length === 0) {
      this.conditions.push({});
    }

    this.modelName = Object.keys(this.mainModel).find(model => this.mainModel[model].model_no === action.model);
    this.model = this.mainModel[this.modelName];
    this.fields = FieldController.getFilterFields(this.model.fields);

    this.autoModel = {};
    this.autoModel.action = action.action;
    this.autoModel.model = this.model.model_key;

    this.setState({
      ...this.state, id: action.id, name: action.name, description: action.description, 
      condition: action.condition_option, roles: action.roles, users: action.users
    });
  }

  onSchedulerChange = (execute, execute_no, execute_select) => {
    this.scheduler = { execute, execute_no, execute_select };
  }

  nameChange = event => this.setState({ ...this.state, name: event.target.value });
  desChange = event => this.setState({ ...this.state, description: event.target.value });
  onModelChange = selected => {
    if (selected.model !== '') {
      this.autoModel = selected;
      this.modelName = selected.model;
      this.autoModel.action = selected.action;
      this.model = this.mainModel[selected.model];
      this.conditions = [{}];
      this.fields = FieldController.getFilterFields(this.model.fields);
      this.setState({ ...this.state, changed: !this.state.changed });
    }
  }
  onActionChange = action => this.autoModel.action = action;
  
  onValueChange = (field, value) => {
    const state = { ...this.state };
    state[field] = value;
    this.setState({ ...this.state, ...state });
  }

  onConditionChanged = conditions => this.conditions = conditions;
  onUpdateChanged = updates => this.updates = updates;

  getSmsOpt = val => val !== 0 ? this.mainModel.sms_temp.options.find(opt => opt.value === val) : val;
  getEmailOpt = val => val !== 0 ? this.mainModel.email_temp.options.find(opt => opt.value === val) : val;
  toggleChange = tog => this.setState({ ...this.state, condition: tog ? Const.True : Const.False });
  getValue = option => option !== undefined ? option !== 0 ? option.value : option : 0;
  onSave = () => {
    let conditions = this.conditions.filter(condition => condition && Object.keys(condition).length > 0)
      .map(filter => { return { field: filter.field.value, type: filter.field.type, condition: filter.condition.value, value: filter.value } });
    conditions = JSON.stringify(conditions);
    
    this.setState({ ...this.state, inApiCall: true });
    const action = {
      id: this.state.id, 
      name: this.state.name,
      description: this.state.description, 
      condition_option: this.state.condition,
      conditions,
      roles: this.state.roles,
      users: this.state.users
    };

    action.model = this.model.model_no;
    action.action = this.autoModel.action;

    ActionAPI.save(action, this.onSaved, this.onFail);
  }

  onSaved = () => {
    Util.showNotification('Successful', 'Successfully saved.', 'success');
    this.props.navigate(this.basePath);
  }

  render() {
    return (
      <div className="sectionform pt-4">
        <div className="container form-cont">

          <div className="row"><div className="col-md-12"><h3>Custom Action Permission</h3></div></div>

          <ApiUiController inApiCall={this.props.inApiCall}>
            <Form className="row row-cols-3 lead-form">
              <div className="col-md-4">
                <div className="form-group">
                  <FormControl type='text' placeholder='Name'
                    className="mr-sm-2" value={this.state.name} onChange={this.nameChange} />
                </div>
              </div>

              <div className="col-md-4">
                <div className="form-group">
                  <Form.Group className="mb-3">
                    <Form.Label>Discription</Form.Label>
                    <Form.Control as="textarea" rows={3}
                      className="mr-sm-2" value={this.state.description} onChange={this.desChange} />
                  </Form.Group>
                </div>
              </div>

              <div className="formhead col-md-12"><h4>Assign permission to Role or User</h4></div>
              <FieldMultiSelect key="roles" id="roles"
                field={this.mainModel.view.fields.roles} value={this.state.roles}
                onValueChange={this.onValueChange} inValid={{}} />

              <FieldMultiSelect key="users" id="users"
                field={this.mainModel.view.fields.users} value={this.state.users}
                onValueChange={this.onValueChange} inValid={{}} />

              <div className="formhead col-md-12"><h4>Module</h4></div>
              <ActionModel onModelChange={this.onModelChange} onActionChange={this.onActionChange} value={this.autoModel} />

              <div className="formhead col-md-12">
                <h4>Condition</h4>
                <div className="display-flixr">
                  <div className="col-md-1">
                    <Form.Check type="radio">
                      <Form.Check.Input type="radio" checked={this.state.condition === Const.True}
                        onChange={() => this.toggleChange(true)} />
                      <Form.Check.Label>AND</Form.Check.Label>
                    </Form.Check>
                  </div>
                  <div className="col-md-2">
                    <Form.Check type="radio">
                      <Form.Check.Input type="radio" checked={this.state.condition !== Const.True}
                        onChange={() => this.toggleChange(false)} />
                      <Form.Check.Label>OR</Form.Check.Label>
                    </Form.Check>
                  </div>
                </div>
              </div>

              <Condition model={this.model} fields={this.fields} eKey="conditions"
                value={this.conditions} onConditionChanged={this.onConditionChanged} />

              <div className="col-md-12 text-center btnsend">
                <Button variant="success" onClick={this.onSave}>Save</Button>
              </div>
            </Form>
          </ApiUiController>
        </div>
      </div>
    );
  }
}
export default withRouter(ActionUpdate);
